import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ClosingSection() {
  return <section className="w-full bg-motor-black py-20 px-4 sm:px-6 lg:px-8 metal-texture" data-id="element-47">
      <div className="max-w-5xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-10" data-id="element-49">
          <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-white uppercase leading-tight" data-id="element-50">
            Si tenés un motor 2T,{' '}
            <span className="text-motor-red" data-id="element-51">
              esto puede ahorrarte cientos en reparaciones
            </span>
          </h2>

          <p className="text-xl sm:text-2xl text-gray-300 font-montserrat font-medium max-w-3xl mx-auto" data-id="element-52">
            Dejá de depender de mecánicos y empezá a entender tu motor hoy mismo
          </p>

          <motion.button whileHover={{
          scale: 1.05,
          boxShadow: '0 0 50px rgba(225, 6, 0, 0.7)'
        }} whileTap={{
          scale: 0.95
        }} className="bg-motor-red text-white font-bebas text-3xl px-12 py-6 rounded-none uppercase tracking-wider shadow-red-glow-lg hover:bg-red-700 transition-all duration-300 flex items-center gap-3 group mx-auto" data-id="element-53">
            ACCEDER AHORA
            <ArrowRight className="w-7 h-7 group-hover:translate-x-1 transition-transform" data-id="element-54" />
          </motion.button>

          <div className="pt-8 border-t border-gray-800" data-id="element-55">
            <p className="text-gray-500 font-montserrat text-sm" data-id="element-56">
              © 2024 Motor 2T Pro. Todos los derechos reservados.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}